"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.marketSegment = void 0;
exports.marketSegment = ['Luxury', 'Hybrid', 'Electric', 'Sport', 'Crossover', 'Exotic'];
